<template>
    <el-container>
        <el-header class="gdc-background-color" height="50px">
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="5" style="margin-left: -20px">
                    <img src="./images/GDC_lgo_1.png" width="71.5" height="50" alt="Logo"/>
                </el-col>
                <!-- <el-col :span="10">
                    <el-row class="row-bg" type="flex" align="middle" justify="end" style="height:100%">
                        <Phone/>
                    </el-row>
                </el-col> -->
            </el-row>
        </el-header>
        <el-main>
            <router-view/>
        </el-main>
    </el-container>
</template>

<script>
import Phone from '../Phone/Phone.vue'
export default {
  name: 'ContainHeaderLayout',
  components: {
    Phone
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContainHeaderLayout/ContainHeaderLayout.vue